/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router';
// material
import { Division, Body, Footer, Link, Feedback, environment, LoadState } from '@insticator/insticator-ui'; // iui-material
import Header from 'material/structure/header/header_container';
import HubSpotModal from 'material/feedback/hubspot/hubspotmodal';
// pages
import Home from 'pages/dashboard/home/home_container';
import Embeds from 'pages/dashboard/embeds/embeds_container';
import Reports from 'pages/dashboard/reports/reports_container';
import Detail from 'pages/dashboard/analytics/detail/detail_container';
import Account from 'pages/dashboard/account/account_container';
import Commenting from 'pages/dashboard/commenting/commenting_container';
import Ratings from 'pages/dashboard/ratings/ratings_container'
import MyProfile from 'pages/dashboard/myprofile/myprofile_container';


const isInIframe = window.top !== window.self

/* ========== ~~~~~~~~~~ DASHBOARD ~~~~~~~~~~ ========== */
class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true
        };
    }
    componentDidMount() {
        this.props.handleDashboardMessage();
        //Booting up intercom as soon as user is logged in
        if(!isInIframe) {
          window.Intercom("boot", {
            app_id: "zm4zzupw",
            name: this.props.mocked ? `MOCKED-${this.props.sessionStatus.userFirstName} ${this.props.sessionStatus.userLastName}` : `${this.props.sessionStatus.userFirstName} ${this.props.sessionStatus.userLastName}`,
            email: this.props.mocked ? `MOCKED-${this.props.sessionStatus.userEmail}` : this.props.sessionStatus.userEmail,
            phone: this.props.sessionStatus.userPhoneNumber,
            user_id: this.props.mocked ? `MOCKED-${this.props.sessionStatus.userUUID}` : this.props.sessionStatus.userUUID
        });
        }
        if(this.state.loading) {
            setTimeout(() => {
                this.setState({loading: false})
            }, 500)
       }
    }
    componentDidUpdate(prevProps) {
        // needs to be here or else their may be a timing issue about receiving this data and showing the message incorrectly
       if (this.props.paymentInfoReceived != prevProps.paymentInfoReceived) {
            if (this.preferredPaymentAdded()) {
                this.props.removeMessage('name', 'preferredpayment', 'incontent', 'messages');
            } else {
                if(!isInIframe) this.showMessage();
            }
       }
        
       // Heap identify and add user properties
       if(this.props.accountName != prevProps.accountName) {
           this.heapIdentify();
       }
    }

    heapIdentify = () => {
        const userEmail = this.props.mocked ? `MOCKED-${this.props.sessionStatus.userEmail}` : this.props.sessionStatus.userEmail;
        const name = this.props.mocked ? `MOCKED-${this.props.sessionStatus.userFirstName} ${this.props.sessionStatus.userLastName}` : `${this.props.sessionStatus.userFirstName} ${this.props.sessionStatus.userLastName}`;
        if(window.heap) {
            window.heap.identify(userEmail);
            window.heap.addUserProperties({ 
                Name: name, 
                Email: userEmail,
                Account: this.props.accountName
            });
        }
    }

    messageAlreadyExists = () => this.props.messageStatus.incontent.messages.some(prop => prop.name === 'preferredpayment');
    paymentInfoReceivedAndPermitted = () => this.props.paymentInfoReceived && this.props.paymentInfoPermitted;
    preferredPaymentAdded = () => this.props.preferredPaymentType != null && this.props.preferredPaymentType != undefined && this.props.preferredPaymentType != '';
    showMessage = () => {
        if (!this.messageAlreadyExists() && this.paymentInfoReceivedAndPermitted()) {
            this.props.displayMessage({
                name: 'preferredpayment',
                type: 'incontent',
                variant: 'neutral',
                icon: `exclamation-triangle`,
                title: null,
                message: <span>There is no Preferred Payment Method selected for your Account: without this, Insticator cannot pay you. <Link type={`internal`} action={`dashboard/account/paymentinfo`} text={<strong>Please add one here.</strong>} color={`primary`} name={`preferredpaymentnotselected`} /></span>,
                close: false,
                handleClose: null,
                enabled: true,
                pages: ['dashboard/home', 'dashboard/analytics/detail', 'dashboard/embeds', 'dashboard/account', 'dashboard/reports'],
                pagesExcluded: ['dashboard/account/paymentinfo', 'dashboard/embeds/management', 'dashboard/reports/detail']
            });
        }
    };
    showFeedbackModal = () => this.props.displayModal(true, <HubSpotModal/>, true);
    _renderLoadState = () => <LoadState graphicName={`insticator-icon`}
                                        graphicText={`Browser with Search Icon`}
                                        bodycopy={`Insticator is loading your data.`} />



    render() {
        if(this.state.loading) return this._renderLoadState()
        return(
            <Division name={`dashboard`}>
                {isInIframe ? '' : <Header />}
                <Body>
                    <Switch>
                        {/*Routes to subsections*/}
                        <Route path='/dashboard/home' component={Home} />{/*/(dashboard/|dashboard/home)/*/}
                        <Route path='/dashboard/analytics/detail' component={Detail} />
                        <Route path='/dashboard/embeds' component={Embeds} />
                        <Route path='/dashboard/reports' component={Reports} />
                        <Route path='/dashboard/account' component={Account} />
                        <Route path='/dashboard/commenting' component={Commenting} />
                        {/* Remove/Hide Ratings Menu and Page */}
                        {/* <Route path='/dashboard/ratings' component={Ratings} /> */}  
                        <Route path='/dashboard/profile' component={MyProfile} />
                        <Redirect to='/error/404' />
                    </Switch>
                    {isInIframe ? '' : <Feedback position={'right'} handleClick={this.showFeedbackModal}/>}
                </Body>
                {isInIframe ? '' : <Footer marginRight={'25px'} />}
            </Division>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Dashboard;
